import { CourseLectureAssignmentStatusEnum } from 'modules/course/types/course-menu-interface'

export const AssignmentsStatusTranslations = {
  [CourseLectureAssignmentStatusEnum.Pending]: 'course.lecture.assignment.pending',
  [CourseLectureAssignmentStatusEnum.Approved]: 'course.lecture.assignment.approved',
  [CourseLectureAssignmentStatusEnum.Rejected]: 'course.lecture.assignment.rejected',
  [CourseLectureAssignmentStatusEnum.NotSubmitted]: 'course.lecture.assignment.not_submitted',
} as const
